import { sendGAEvent } from "../../../../Utils/GAEvents";
import { TRACKING_EVENTS } from "../../../../Utils/GAEvents/gaEventsConstants";
import { DLP_WEBSITE } from "../../../../Utils/cleverTapEventsConstant";
import { clevertapEventPush, getEventPlatform, getUrlParamValue } from "../../../../Utils/common";
import { UTM_SOURCE } from "../../../../Utils/constants";
import { SearchIconSvg } from "../../utils/svgIcons";

export const SearchBar = (props) => {
  const { submitSearch, handleTextChange, searchTxt } = props;

  function handleSearch(searchTxt) {
    if (props?.fromCart) {
      props?.handleSearchRoute();
      clevertapEventPush(DLP_WEBSITE.DOMAIN_SEARCHED, { domain: searchTxt });
      sendGAEvent(TRACKING_EVENTS.searchOncartPage, {
        dimension1: searchTxt,
        dimension2: getEventPlatform(),
        dimension3: getUrlParamValue(UTM_SOURCE),
        // Add more dimensions as needed
      });
    } else {
      submitSearch(searchTxt);
    }
  }

  return (
    <div className="search-bar_container">
      <div className="search_bar_box">
        <input
          onKeyPress={(e) => {
            if (e.which === 13) {
              handleSearch(searchTxt);
            }
          }}
          onChange={(e) => handleTextChange(e.target.value)}
          type="url"
          placeholder={props?.placeholder}
          value={searchTxt}
          maxLength={30}
        />
        <span onClick={() => (searchTxt?.length > 0 ? handleSearch(searchTxt) : null)}>
          <SearchIconSvg />
        </span>
      </div>
    </div>
  );
};
